export default __webpack_public_path__ + "static/media/Professionaljpg.650ee21c.jpeg";